import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IOHMapService } from 'src/app/services/ioh-map.service';
import { IOHBaseMapsComponent } from '../ioh-base-maps/ioh-base-maps.component';

@Component({
  selector: 'csx-map-service-icons',
  templateUrl: './ioh-map-service-icons.component.html',
  styleUrls: ['./ioh-map-service-icons.component.scss'],
  imports: [IOHBaseMapsComponent]
})
export class IOHMapServiceIconsComponent implements OnInit {
  isShowBaseMaps: boolean = false;
  @Output() triggerBaseMap: EventEmitter<boolean> = new EventEmitter<boolean>();
  private destroy$ = new Subject<void>();

  constructor(public iohMapService: IOHMapService) {}

  ngOnInit(): void {
    this.iohMapService.iohHideBaseLayer$
      .pipe(takeUntil(this.destroy$))
      .subscribe(el => {
        this.isShowBaseMaps = el;
      });
  }

  showBaseMapView() {
    this.isShowBaseMaps = !this.isShowBaseMaps;
  }

  hideBaseMaps(event) {
    this.iohMapService.iohHideBaseLayer$.next(event);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
